module.exports = __webpack_public_path__ + "static/media/coming-soon-home.b741c330.svg";